import { render, staticRenderFns } from "./search-price-selector.vue?vue&type=template&id=3df0c36e"
import script from "./search-price-selector.vue?vue&type=script&lang=js"
export * from "./search-price-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports